import { state } from "State";
import databaseCache from "Services/databaseCache";

const waBounds = [
  [-12.328259677742766, 131.33056640625003],
  [-35.335293203093286, 113.92822265625]
];
const qldBounds = [[128, -31].reverse(), [156, -8].reverse()];

// TODO: make this a config option
const maxBounds = qldBounds;

state.select("domain_data").on("update", event => {
  if (
    // All of state
    event.data.currentData.geo_aggregation !==
      event.data.previousData.geo_aggregation &&
    !event.data.currentData.geo_aggregation_value
  ) {
    state.select("map_data").merge({
      boundaries: maxBounds,
      highlight_feature: null
    });
  } else if (
    // A smaller region is selected get it bounding box and update the map
    event.data.currentData.geo_aggregation_value &&
    event.data.currentData.geo_aggregation_value !==
      event.data.previousData.geo_aggregation_value
  ) {
    databaseCache.getData("BOUNDARY_QUERY", { format: "json" }).then(result =>
      result.rows[0]
        .chain(({ minx, maxx, miny, maxy }) => [
          [maxy - 0.3, maxx - 0.3],
          [miny + 0.3, minx + 0.3]
        ])
        .chain(bounds =>
          state.select("map_data").merge({
            boundaries: flattenDeep(bounds).every(v => v) ? bounds : maxBounds,
            highlight_feature: "" // result.features[0]
          })
        )
    );
  }
});

function flattenDeep(arr1) {
  return arr1.reduce(
    (acc, val) =>
      Array.isArray(val) ? acc.concat(flattenDeep(val)) : acc.concat(val),
    []
  );
}



// WEBPACK FOOTER //
// ./services/stateObservers.js